<!--
component: BrowseBuilding2men
author: Ken Nakamura
description: 建築計画概要書（第二面）
-->
<template>
  <section class="A4">
    <p style="font-size: 9pt;">
      注：この建築計画概要書は申請時に提出された原本ではなく、入力データから再構築したものです。
    </p>
    <p class="gaiyo-section-header">
      建築計画概要書（第二面）
    </p>
    <div class="gaiyo-section-subheader">
      建築物及びその敷地に関する事項
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【1.地名地番】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-element left-35">{{gaiyo.gaiyoRec.timeI_TIBAN}}</div>
      </div>
      <div class="gaiyo-row">
        <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.timeI_TIBAN,42)" :key="`timeitiban-${index}`">
          <br v-show="index>0"></div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【2.住居表示】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-element left-35">{{gaiyo.gaiyoRec.jukyO_DISP}}</div>
      </div>
      <div class="gaiyo-row">
        <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.jukyO_DISP,42)" :key="`jukyodisp-${index}`">
          <br v-show="index>0"></div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【3.都市計画区域及び準都市計画区域の内外の別等】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-35">
          <Checkbox :checked="gaiyo.gaiyoRec.citY_PLAN_KUIKI==1" caption=" 都市計画区域内"/>
        </div>
        <div class="gaiyo-element left-65">
          （ <Checkbox :checked="gaiyo.cityPlanDetail1==1" caption="市街化区域"/>
        </div>
        <div class="gaiyo-element left-95">
          <Checkbox :checked="gaiyo.cityPlanDetail2==1" caption="市街化調整区域"/>
        </div>
        <div class="gaiyo-element left-130">
          <Checkbox :checked="gaiyo.cityPlanDetail3==1" caption="区域区分非設定 ）"/>
        </div>
      </div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-35">
          <Checkbox :checked="gaiyo.gaiyoRec.citY_PLAN_KUIKI==2" caption=" 準都市計画区域内"/>
        </div>
        <div class="gaiyo-element left-80">
          <Checkbox :checked="gaiyo.gaiyoRec.citY_PLAN_KUIKI==3" caption=" 都市計画区域及び準都市計画区域外"/>
        </div>
      </div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【4.防火地域】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-element left-35">
          <Checkbox :checked="gaiyo.bokaTiiki==1" caption=" 防火地域"/>
        </div>
        <div class="gaiyo-element left-60">
          <Checkbox :checked="gaiyo.subBokaTiiki==1" caption=" 準防火地域"/>
        </div>
        <div class="gaiyo-element left-90">
          <Checkbox :checked="gaiyo.appoNasi==1" caption=" 指定なし"/>
        </div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【5.その他の区域、地域、地区、街区】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-35">
          <Checkbox :checked="gaiyo.law22Kuiki==1" caption=" 法第２２条区域"/>
        </div>
        <div class="gaiyo-element left-70">
          <Checkbox :checked="gaiyo.law52Kuiki==1" caption=" 法第５２条第７項運用区域"/>
        </div>
      </div>
      <br>
    </div>
    <div class="gaiyo-row"
      v-for="(lin, index) in wordwrap(gaiyo.gaiyoRec.etC_TIIKI, 40)"
      :key="`etc-${index}`">
        <div class="gaiyo-element left-35">
            {{lin}}
        </div><br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【6.道路】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.幅員】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">
          {{(gaiyo.gaiyoRec.dorO_WIDTH / 1000).toFixed(3)}} m
        </div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.敷地と接している部分の長さ】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">
          {{(gaiyo.gaiyoRec.dorO_SETUDO_LENGTH / 1000).toFixed(3)}} m
        </div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【7.敷地面積】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.敷地面積】</div>
      <div class="gaiyo-element left-35">(1)</div>
      <div class="gaiyo-element left-40">(</div>
      <div class="gaiyo-element left-70">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-105">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-140">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-175">&nbsp;&nbsp;)</div>
      <div class="area-item area-1">{{fmt(gaiyo.siteArea11, 2)}} ㎡</div>
      <div class="area-item area-2">{{fmt(gaiyo.siteArea12, 2)}} ㎡</div>
      <div class="area-item area-3">{{fmt(gaiyo.siteArea13, 2)}} ㎡</div>
      <div class="area-item area-4">{{fmt(gaiyo.siteArea14, 2)}} ㎡</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-35">(2)</div>
      <div class="gaiyo-element left-40">(</div>
      <div class="gaiyo-element left-70">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-105">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-140">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-175">&nbsp;&nbsp;)</div>
      <div class="area-item area-1">{{fmt(gaiyo.siteArea21, 2)}} ㎡</div>
      <div class="area-item area-2">{{fmt(gaiyo.siteArea22, 2)}} ㎡</div>
      <div class="area-item area-3">{{fmt(gaiyo.siteArea23, 2)}} ㎡</div>
      <div class="area-item area-4">{{fmt(gaiyo.siteArea24, 2)}} ㎡</div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.用途地域等】</div>
      <div class="gaiyo-element left-40">(</div>
      <div class="gaiyo-element left-70">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-105">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-140">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-175">&nbsp;&nbsp;)</div>
      <div class="area-yoto-item left-40">&nbsp;{{gaiyo.gutaiYotoTiiki1}}</div>
      <div class="area-yoto-item left-75">&nbsp;&nbsp;{{gaiyo.gutaiYotoTiiki2}}</div>
      <div class="area-yoto-item left-110">&nbsp;&nbsp;{{gaiyo.gutaiYotoTiiki3}}</div>
      <div class="area-yoto-item left-180">&nbsp;&nbsp;{{gaiyo.gutaiYotoTiiki4}}</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾊ.建築基準法第５２条第１項及び第２項の規定による建築物の容積率】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-40">(</div>
      <div class="gaiyo-element left-70">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-105">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-140">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-175">&nbsp;&nbsp;)</div>
      <div class="area-item area-1">{{gaiyo.appoYoseki1}} %</div>
      <div class="area-item area-2">{{gaiyo.appoYoseki2}} %</div>
      <div class="area-item area-3">{{gaiyo.appoYoseki3}} %</div>
      <div class="area-item area-4">{{gaiyo.appoYoseki4}} %</div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾆ.建築基準法第５３条第１項の規定による建築物の建蔽率】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-40">(</div>
      <div class="gaiyo-element left-70">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-105">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-140">&nbsp;&nbsp;)(</div>
      <div class="gaiyo-element left-175">&nbsp;&nbsp;)</div>
      <div class="area-item area-1">{{gaiyo.appoKenpei1}} %</div>
      <div class="area-item area-2">{{gaiyo.appoKenpei2}} %</div>
      <div class="area-item area-3">{{gaiyo.appoKenpei3}} %</div>
      <div class="area-item area-4">{{gaiyo.appoKenpei4}} %</div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾎ.敷地面積の合計】</div>
      <div class="gaiyo-element left-60">(1)</div>
      <div class="area-item area-2">{{fmt(gaiyo.gaiyoRec.sitE_AREA_SUM1, 2)}} ㎡</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-60">(2)</div>
      <div class="area-item area-2">{{fmt(gaiyo.gaiyoRec.sitE_AREA_SUM2, 2)}} ㎡</div>
    </div>
    <br>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾍ.敷地に建築可能な延べ面積を敷地面積で除した数値】</div>
      <div class="area-item area-3">{{gaiyo.gaiyoRec.nB_AREA_RATIO}} %</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾄ.敷地に建築可能な建築面積を敷地面積で除した数値】</div>
      <div class="area-item area-3">{{gaiyo.gaiyoRec.blD_AREA_RATIO}} %</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾁ.備考】</div>
      <div class="gaiyo-element left-25">{{gaiyo.gaiyoRec.sitE_AREA_SUM_BIKO}}</div>
      <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.sitE_AREA_SUM_BIKO,44)" :key="`areabiko-${index}`">
        <br v-show="index>0">
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【8.主要用途】</div>
      <div class="gaiyo-element left-30">（区分 {{gaiyo.yotoCode}}）</div>
      <div class="gaiyo-element left-60">{{gaiyo.gaiyoRec.gutaI_SYUYO_YOTO}}</div>
        <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.gutaI_SYUYO_YOTO,32)" :key="`yoto-${index}`">
          <br v-show="index>0"></div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【9.工事種別】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-10">
        <Checkbox caption="新築" :checked="gaiyo.kojiShinchiku" />
      </div>
      <div class="gaiyo-element left-25">
        <Checkbox caption="増築" :checked="gaiyo.kojiZouchiku" />
      </div>
      <div class="gaiyo-element left-40">
        <Checkbox caption="改築" :checked="gaiyo.kojiKaichiku" />
      </div>
      <div class="gaiyo-element left-55">
        <Checkbox caption="移転" :checked="gaiyo.kojiIten" />
      </div>
      <div class="gaiyo-element left-70">
        <Checkbox caption="用途変更" :checked="gaiyo.kojiYouto" />
      </div>
      <div class="gaiyo-element left-90">
        &nbsp;<Checkbox caption="大規模の修繕" :checked="gaiyo.kojiShuzen" />
      </div>
      <div class="gaiyo-element left-120">
        <Checkbox caption="大規模の模様替" :checked="gaiyo.kojiMoyo" />
      </div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【10.建築面積】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-header left-65">申請部分</div>
        <div class="gaiyo-header left-100">&nbsp;申請以外の部分</div>
        <div class="gaiyo-header item-3">合計</div>
      </div>
    </div>
    <!-- 法改正対応： 【ｲ.建築物全体】を追加 データ部は未修正 -->
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.建築物全体】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt3(gaiyo.gaiyoRec.blD_TOTAL_BBN, 2)}} {{unitDisp(fmt3(gaiyo.gaiyoRec.blD_TOTAL_BBN, 2),'㎡')}}</div>
        <div class="gaiyo-item item-2">{{fmt3(gaiyo.gaiyoRec.blD_TOTAL_IGI, 2)}} {{unitDisp(fmt3(gaiyo.gaiyoRec.blD_TOTAL_IGI, 2),'㎡')}}</div>
        <div class="gaiyo-item item-3">{{fmt3(gaiyo.gaiyoRec.blD_TOTAL_SUM, 2)}} {{unitDisp(fmt3(gaiyo.gaiyoRec.blD_TOTAL_SUM, 2),'㎡')}}</div>
      </div>
    </div>
    <!-- 法改正対応：【ｲ.建築面積】⇒【ﾛ.建蔽率の算定の基礎となる建築面積】 -->
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.建蔽率の算定の基礎となる建築面積】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.blD_AREA_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.blD_AREA_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.blD_AREA_SUM, 2)}} ㎡</div>
      </div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾊ.建蔽率】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.blD_AREA_KENPEI, 2)}} ％</div>
      </div>
    </div>
    <hr>
    <div v-show="nobemenVisible">
      <BrowseBuildingNobemen :gaiyo="gaiyo" />
    </div>
  </section>
</template>

<script>
import { wordwrap } from '../common/utils';
import BrowseBuildingNobemen from '../components/building/BrowseBuildingNobemen.vue';
import Checkbox from '../components/Checbox.vue';

export default {
  components: {
    BrowseBuildingNobemen,
    Checkbox,
  },
  props: {
    nobemenVisible: {
      type: Boolean,
      default: () => true
    },
    gaiyo: {
      type: Object,
      default: null
    },
  },
  computed: {
  },
  methods: {
    fmt(val, prec) {
      const v = (val == null) ? 0 : val;
      return v.toFixed(prec);
    },
    fmt2(val, width, prec, unit) {
      const v = (val == null) ? 0 : val;
      const fixedVal = v.toFixed(prec);
      const padVal = ("            " + fixedVal).substr(-12);
      return '(' + padVal + ' ' + unit + ')';
    },
    fmt3(val,prec){
      return val == null ? '' : val.toFixed(prec);
    },
    unitDisp(val,unit){
      return val == '' ? '' : unit;
    },
    wordwrap(text, len) {
      /*
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
      */
      return wordwrap(text, len);
    },
  },
}
</script>

<style lang="scss">
</style>
